import { visuallyHidden } from '@juvare/common-form-ui/utils/visualyHidden';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { Checkbox, InputLabel, TableCell, TableRow, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { convertArrayToString } from '../../utils/convertArrayToString';
import { toKebabCase } from '../../utils/toKebabCase';
export function DesktopColumns({ row, rowIndex, readonly, columns, isItemSelected, actions, onRowClick, onCheckboxClick, }) {
    const { t } = useTranslation();
    return (React.createElement(TableRow, { key: `desktopColumns-${rowIndex}`, hover: !!actions, "data-test": row.id + '-row', onClick: () => {
            onRowClick && onRowClick(row);
        }, sx: {
            alignItems: 'center',
            borderBottom: `1px solid ${themeColors.border.main}`,
            cursor: onRowClick ? 'pointer' : undefined,
            display: 'flex',
            gap: 2,
            py: 2,
            width: '100%',
        } },
        !readonly && (React.createElement(TableCell, { padding: 'checkbox', sx: { display: 'flex', borderBottom: 'none' } },
            React.createElement(Checkbox, { color: 'primary', checked: isItemSelected, inputProps: {
                    'aria-labelledby': `${row.id}-checkbox`,
                }, onClick: (event) => {
                    event.stopPropagation();
                    onCheckboxClick && onCheckboxClick(row.id);
                } }),
            React.createElement(InputLabel, { id: `${row.id}-checkbox`, sx: visuallyHidden }, t('selectRow')))),
        columns.map((column, columnIndex, array) => {
            const isLastColumn = columnIndex >= array.length - 1;
            const columnValue = row.columns[column.value];
            const columnDataTest = `${toKebabCase(column.label)}-column`;
            let value;
            if (column.render) {
                value = (React.createElement(React.Fragment, { key: `desktopColumn-${columnIndex}` }, column.render(row, columns.map((column) => column.value))));
            }
            else if (columnValue !== null && columnValue !== undefined) {
                value = (React.createElement(Typography, { variant: 'body2', sx: {
                        borderBottom: 'none',
                        color: (theme) => theme.palette.grey['700'],
                        display: 'flex',
                        flexGrow: 1,
                        width: '100%',
                        p: 0,
                        wordBreak: 'break-word',
                        maxWidth: column.maxWidth,
                    }, key: `desktopColumn-${columnIndex}`, "data-test": columnDataTest }, convertArrayToString(columnValue)));
            }
            if (columnIndex === 0) {
                return (React.createElement(TableCell, { key: `desktopColumn-${row.id + columnIndex}`, component: 'th', scope: 'row', sx: {
                        borderBottom: 'none',
                        display: 'flex',
                        p: 0,
                        width: '100%',
                        maxWidth: column.maxWidth,
                    }, "data-test": columnDataTest }, value));
            }
            return (React.createElement(TableCell, { key: `desktopColumn-${row.id + columnIndex}`, align: 'left', sx: {
                    borderBottom: 'none',
                    display: 'flex',
                    p: 0,
                    width: '100%',
                    maxWidth: column.maxWidth,
                    whiteSpace: isLastColumn ? 'nowrap' : 'normal',
                }, "data-test": columnDataTest }, value));
        }),
        !readonly && actions && (React.createElement(TableCell, { sx: {
                alignItems: 'flex-end',
                borderBottom: 'none',
                display: 'flex',
                p: 0,
                width: '100%',
            }, align: 'right', "data-test": 'actions' }, actions))));
}
